import React from 'react';
import { Drawer as AntDrawer, DrawerProps as AntDrawerProps } from 'antd';
import { createGlobalStyle, useTheme } from 'styled-components';
import { DrawerHeader } from './next/header';
import { DrawerBody } from './next/body';
import { DrawerFooter } from './next/footer';

const NextDrawerStyles = createGlobalStyle`
  .ant-drawer-next {
    .ant-drawer-content-wrapper {
      box-shadow: none;
      border-left: 1px solid ${({ theme }) => theme.token.next.colorBorder};
    }
    .ant-drawer-mask {
      background-color: ${({ theme }) => theme.token.colorBgMask};
    }
  }
`;

interface DrawerComponentProps extends AntDrawerProps {
  variant?: 'next';
  maskVariant?: 'default' | 'transparent' | 'none';
}

const DrawerBase = ({
  title,
  open,
  onClose,
  children,
  bodyStyle,
  placement,
  variant,
  width,
  ...props
}: DrawerComponentProps) => {
  const { token } = useTheme();

  if (variant === 'next') {
    return (
      <>
        <NextDrawerStyles />
        <AntDrawer
          open={open}
          onClose={onClose}
          placement={placement}
          width={width ?? 320}
          closable={false}
          title={null}
          mask={props.maskVariant !== 'none'}
          maskStyle={props.maskVariant === 'transparent' ? { backgroundColor: 'transparent' } : {}}
          headerStyle={{ display: 'none' }}
          bodyStyle={{
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
          {...props}
          rootClassName="ant-drawer-next"
        >
          {children}
        </AntDrawer>
      </>
    );
  }

  const defaultHeaderStyle = {
    padding: `${token.paddingLG}px`,
    borderBottom: `1px solid ${token.colorBorder}`,
    color: `${token.colorText}`,
  };

  return (
    <AntDrawer
      title={title}
      placement={placement}
      closable={false}
      onClose={onClose}
      open={open}
      width={width ?? 480}
      headerStyle={{
        padding: `${token.paddingLG}px`,
        borderBottom: `1px solid ${token.colorBorder}`,
        color: `${token.colorText}`,
      }}
      bodyStyle={bodyStyle ?? defaultHeaderStyle}
      {...props}
    >
      {children}
    </AntDrawer>
  );
};

export const Drawer = Object.assign(DrawerBase, {
  Header: DrawerHeader,
  Body: DrawerBody,
  Footer: DrawerFooter,
});

export type { DrawerProps } from 'antd';
